import { ExportLineItems } from "./ExportLineItems";

export class ExportDeclaration {
    InvoiceDate: any; 
    InvoiceNumber: any; 
    ExportLineItems: ExportLineItems;    
}